import Backbone from 'backbone'
import labelTemplate from './color-picker-menu-label.hbs'
import ColorPicker from 'scoreboard/components/color-picker'
const { PERFORMANCE, AUTO } = ColorPicker
const ColorPickerOptions = ColorPicker.options
import { rawColors } from 'scoreboard/components/rich-text/command-options'
import updateSelectedWobs from './update-selected-wobs'

import constants from 'scoreboard/components/constants'

var OutlineColorLabelView = Backbone.View.extend({
	className: 'config-color',

	initialize: function (opt) {
		this.listenTo(this.source.model, 'change:' + this.source.property, this.render.bind(this))
	},

	render: function () {
		let color = this.source.model.get(this.source.property)
		let svg
		if (color === PERFORMANCE || color === AUTO) {
			// If using performance/auto color, we need to specify that specific
			// icon, since it isn't just styled with CSS
			svg = 'performance-circle'
		}

		this.$el.html(labelTemplate({
			svg,
			color,
			label: this.label
		}))

		return this
	}
})

/**
 * Returns a menu item and submenu for picking colors in a bootslide tooltip menu.
 *
 * @param {object} bootslideMenu
 * the scoreboard/components/bootslide/bootslide-menu instance
 *
 * @param {object} widgetModel
 * the Backbone.Model for the widget
 *
 * @param {object} opt
 *
 * @param {array} [opt.colors]
 * 2D array of colors to be used for the color picker grid;
 * defaults to
 * import CommandOptions from 'scoreboard/components/rich-text/command-options'
 * const { rawColors } = CommandOptions
 *
 * @param {string} opt.label
 * the text used for the label in the menu item and the header for the submenu
 *
 * @param {object} opt.source.model
 * the Backbone.Model that can be queried for the the current color value
 *
 * @param {string} opt.source.property
 * the attribute in opt.source.model that contains the current color value
 *
 * @param {function} opt.propertySetter
 * function that is called when a color is picked; the function is responsible
 * for doing any necessary model updates
 */
function createMenu (bootslideMenu, widgetModel, opt = {}) {
	let colors = opt.colors || rawColors()

	return {
		width: constants.COLOR_PICKER_MENU_WIDTH,
		type: 'value-then-submenu',
		id: opt.id,
		label: opt.label,
		contentView: OutlineColorLabelView.extend({
			source: opt.source,
			label: opt.label
		}),
		hidden: opt.hidden,
		contentEndpoint: function () {
			var v = new ColorPickerOptions({
				colors,
				color: opt.source.model.get(opt.source.property)
			})

			bootslideMenu.childViews.push(v)

			let onSelect = opt.onSelect
			if (!onSelect) {
				onSelect = selected => {
					widgetModel.trigger('record')

					updateSelectedWobs(bootslideMenu.canvas, wob => {
						opt.propertySetter(wob, selected)
					})
				}
			}

			v.on('select', onSelect)

			opt.source.model.on('change:' + opt.source.property, () => {
				v.color = opt.source.model.get(opt.source.property)
				v.render()
			})

			return v.render().el
		}.bind(this)
	}
}

export default createMenu

createMenu.__filename__ = 'dashboards/widgets/color-picker-menu.js'
